import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-left">
          <Link to="/" className="navbar-logo-container">
            <img src="/logo.png" alt="WEP Logo" className="navbar-logo-img" />
          </Link>
          <ul className="navbar-menu">
            <li className="navbar-item">
              <Link to="/about" className="navbar-link">
                About
              </Link>
            </li>
            <li className="navbar-item">
              <Link to="/mentorship" className="navbar-link">
                Mentorship
              </Link>
            </li>
            <li className="navbar-item">
              <Link to="/podcast" className="navbar-link">
                Podcast
              </Link>
            </li>
            <li className="navbar-item">
              <Link to="/events" className="navbar-link">
                Events
              </Link>
            </li>
            <li className="navbar-item">
              <Link to="/newsletter" className="navbar-link">
                Newsletter
              </Link>
            </li>
            <li className="navbar-item">
              <Link to="/resources" className="navbar-link">
                Resources
              </Link>
            </li>
          </ul>
        </div>
        <Link to="/contact" className="navbar-cta">
          Contact Us
        </Link>
      </div>
    </nav>
  );
}

export default Navbar;

